/**
 * Every user-visible string for the give-an-award sheet. Verbatim from
 * `.agents/views/26-pool-members.html`. Kept separate from
 * `poolAwardsCopy.ts` because this sheet is reached from the members screen,
 * not from settings, and the two modules must not import each other.
 */
import {
  kindLabelPlural,
  kindLabelSingular,
  kindNoun,
  type typeAwardKind,
} from "./poolAwardsCopy";

export const GIVE_AWARD_TAKE_BACK_LABEL = "Take back";
export const GIVE_AWARD_SUBMIT_LABEL = "Give award";

export function giveAwardTitle(firstName: string): string {
  return `Give an award to ${firstName}`;
}

export function giveAwardSubtitle(poolName: string): string {
  return `Custom awards for ${poolName}. Given and taken awards are announced in the pool's chat.`;
}

export function giveAwardRowLine(input: {
  kind: typeAwardKind;
  firstName: string;
  heldCount: number;
}): string {
  if (input.heldCount === 0) {
    return kindLabelSingular(input.kind);
  }
  return `${kindLabelSingular(input.kind)} · ${input.firstName} holds ${input.heldCount}`;
}

export function giveAwardKindEmptyLine(kind: typeAwardKind): string {
  return `No ${kindNoun(kind, 1)} types to give right now.`;
}

export function giveAwardKindLabel(kind: typeAwardKind): string {
  return kindLabelPlural(kind);
}

export function firstNameOf(displayName: string): string {
  const firstToken = displayName.split(/\s+/).find((token) => token !== "");
  return firstToken ?? displayName;
}
